
import { OnInit, Input, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ModuleHelper } from '../../helpers/module.helper';
import { CropCycleOverviewHeaderApiModel } from '../../models/cropCycleOverview/cropCycleOverviewHeaderApiModel';


@Component({
    selector: 'app-crop-cycles-information-header',
    templateUrl: './crop-cycles-information-header.component.html',
    styleUrls: ['./crop-cycles-information-header.component.scss'],
    standalone: false
})
export class CropCyclesInformationHeaderComponent implements OnInit {

  @Input() cropCycleContainerWidth: number;
  @Input() pageSize: number;
  @Input() cropCycles: CropCycleOverviewHeaderApiModel[];

  constructor(
    private readonly translationService: TranslateService,
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly moduleHelper: ModuleHelper) { }

  ngOnInit() {
  }


  goToCropCycleInsightsPage(cropCycle: CropCycleOverviewHeaderApiModel) {
    const route = this.getInsightsPageRoute(cropCycle);
    this.router.navigate(route);
  }

  getInsightsPageRoute(cropCycle: CropCycleOverviewHeaderApiModel) {
    const organizationId = +this.activatedRoute.snapshot.paramMap.get('organizationId');
    const module = this.moduleHelper.getModuleRoute();
    return [module, 'organizations', organizationId, 'insights','sites', cropCycle.siteId, 'crops',
    cropCycle.cropCycleId];
  }

  getCropCyclePeriodLabel(cropCycle: CropCycleOverviewHeaderApiModel) {
    let weekLabel = '';

    if (cropCycle.cropCycleCurrentWeek !== null && cropCycle.cropCycleCurrentWeek !== undefined) {
      weekLabel = this.translationService.instant("Shell.cropCycleTemplates.week");
    } else if (cropCycle.cropCycleCurrentWeek === null || cropCycle.cropCycleCurrentWeek === undefined) {
      weekLabel = this.translationService.instant("Shell.newOrganizations.pages.cropCycles.weeks");
    }

    let currentWeekLabel = cropCycle.cropCycleCurrentWeek !== null &&
    cropCycle.cropCycleCurrentWeek !== undefined ? `${cropCycle.cropCycleCurrentWeek}/` : '';

    return `${weekLabel} ${currentWeekLabel}${cropCycle.cropCycleTotalWeeks}`;
  }
}
